import {GetSeferData} from "SeferPetach/GetData";

export async function getColorsList() {
    var args = {
        'TYPE_ID': 4,
        'ITEM_STATUS': 1
    };
    var payload = await GetSeferData("af3", args);
    return (payload);
}

export async function getColorByID(file_id, type_id){
    var args = {
        'FILE_ID': file_id,
        'TYPE_ID': type_id
    };
    var payload = await GetSeferData("af4", args);
    return (payload);
}

export async function updateColor(obj) {
    var args        = obj;
    var payload     = await GetSeferData("af1", args);
    return (payload);
}

export async function deleteColor(file_id, type_id){
    var args = {
        'FILE_ID': file_id,
        'TYPE_ID': type_id
    };
    var payload = await GetSeferData("af5", args);
    return (payload);
}